import { RegistrationModalConnector } from '@/contacts/components/registration-modal/connector';
import { RegistrationModalComponent } from '@/contacts/components/registration-modal/component';

export const RegistrationModal = RegistrationModalConnector(RegistrationModalComponent);
